import { connect } from 'react-redux';

import { IState } from '../../store';
import { AsideBanners, IAsideBannersStoreProps } from './index';

function mapStateToProps(state: IState): IAsideBannersStoreProps {
  return {
    height: state.aside.height,
  };
}

export const AsideBannersContainer = connect<IAsideBannersStoreProps, {}, {}>(mapStateToProps)(AsideBanners);
